import { ThunkDispatch } from "redux-thunk";

import { connect } from 'react-redux';

import ProgressStepper from '../components/ProgressStepperView';

import { setProcessStep, Action } from '../actions';
import { ProcessStep } from "../constants";
import { getProcessStep, State } from '../reducers';


interface StateProps {
    readonly processStep: ProcessStep,
}

interface DispatchProps {
    readonly onProcessStepChanged: (processStep: ProcessStep) => void,
}


const mapStateToProps = (state: State): StateProps => (
    {
        processStep: getProcessStep(state),
    }
);

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onProcessStepChanged: (processStep: ProcessStep) => {
            dispatch(setProcessStep(processStep));
        },
    }
);


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProgressStepper);



// WEBPACK FOOTER //
// ./src/containers/ProgressStepper.ts